import { apiService } from './apiService';

export const subscriptionService = {
  // Add coins to a user's subscription
  addCoins: async (userId, coins, reason = '') => {
    try {
      const payload = {
        coins,
        reason
      };

      const response = await apiService.post(`/subscription/coins/${userId}`, payload);

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Coins added successfully'
      };
    } catch (error) {
      console.error('Add coins error:', error);

      let errorMessage = 'Failed to add coins. Please try again.';

      if (error.response) {
        const apiError = error.response.data?.detail || error.response.data?.message || error.response.data;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      } else {
        errorMessage = error.message || errorMessage;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  }
  ,
  // Create a new subscription plan
  addPlan: async (name, credits, price, type = 'pack') => {
    try {
      const payload = {
        name,
        credits,
        price,
        type
      };

      const response = await apiService.post(`/subscription/plan`, payload);

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Subscription plan created successfully'
      };
    } catch (error) {
      console.error('Add plan error:', error);

      let errorMessage = 'Failed to create subscription plan. Please try again.';

      if (error.response) {
        const data = error.response.data;
        let apiError = data?.detail || data?.message;

        if (!apiError && Array.isArray(data?.errors)) {
          apiError = data.errors.join('\n');
        }

        if (!apiError && data && typeof data === 'object') {
          apiError = JSON.stringify(data);
        }

        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      } else {
        errorMessage = error.message || errorMessage;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  }
  ,
  // Get all subscription plans
  getPlans: async () => {
    try {
      const response = await apiService.get(`/subscription/plan`);

      return {
        success: true,
        data: response.data.result || response.data,
        message: response.data?.message || 'Plans fetched successfully'
      };
    } catch (error) {
      console.error('Get plans error:', error);

      let errorMessage = 'Failed to fetch plans. Please try again.';

      if (error.response) {
        const apiError = error.response.data?.detail || error.response.data?.message || error.response.data;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      } else {
        errorMessage = error.message || errorMessage;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },
  
  // Get transaction history for a specific user
  getTransactionHistory: async (userId) => {
    try {
      const response = await apiService.get(`/subscription/transaction-history/${userId}`);

      return {
        success: true,
        data: response.data.result || response.data,
        coins: response.data.coins,
        message: response.data?.message || 'Transaction history fetched successfully'
      };
    } catch (error) {
      console.error('Get transaction history error:', error);

      let errorMessage = 'Failed to fetch transaction history. Please try again.';

      if (error.response) {
        const data = error.response.data;
        let apiError = data?.detail || data?.message;

        if (!apiError && Array.isArray(data?.errors)) {
          apiError = data.errors.join('\n');
        }

        if (!apiError && data && typeof data === 'object') {
          apiError = JSON.stringify(data);
        }

        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      } else {
        errorMessage = error.message || errorMessage;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Get all user transactions
  getUserTransactions: async () => {
    try {
      const response = await apiService.get(`/subscription/user/transactions`);

      return {
        success: true,
        data: response.data.result || response.data,
        message: response.data?.message || 'Transactions fetched successfully'
      };
    } catch (error) {
      console.error('Get transactions error:', error);

      let errorMessage = 'Failed to fetch transactions. Please try again.';

      if (error.response) {
        const apiError = error.response.data?.detail || error.response.data?.message || error.response.data;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      } else {
        errorMessage = error.message || errorMessage;
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  }
};

export default subscriptionService;
